/**
 * Mirrors the prototype's `.ph`: sticky under the topbar with a blurred
 * backdrop, an amber eyebrow, and a Rajdhani display title.
 */
.header {
  display: flex;
  align-items: center;
  gap: var(--sp-5);
  padding: var(--sp-6) var(--sp-8);
  border-bottom: 1px solid var(--line);
  background: var(--bg2);
  position: sticky;
  top: 0;
  z-index: 90;
  backdrop-filter: blur(6px);
}
.eyebrow {
  margin-bottom: 3px;
  color: var(--text-warn);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
}
.title {
  font-family: var(--font-display);
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  color: var(--text);
}
.subtitle {
  margin-top: 4px;
  color: var(--sage);
  font-size: 11px;
  line-height: 1.5;
}
.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-3);
  align-items: center;
  margin-left: auto;
}
